var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kt-pagination" }, [
    _c(
      "ul",
      { staticClass: "kt-pagination__links" },
      [
        _vm.pages.length > 1
          ? [
              _c(
                "li",
                {
                  staticClass: "kt-pagination__link--first",
                  class: {
                    "kt-pagination__link--disabled": _vm.currentPage === 1,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.getPageUrl(1) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changePage(1)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-angle-double-left" })]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "kt-pagination__link--prev",
                  class: {
                    "kt-pagination__link--disabled": _vm.currentPage - 1 <= 0,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.getPageUrl(_vm.currentPage - 1) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changePage(_vm.currentPage - 1)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-angle-left" })]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.pages, function (pageNumber) {
                return _c(
                  "li",
                  {
                    key: pageNumber,
                    class: {
                      "kt-pagination__link--active":
                        pageNumber === _vm.currentPage,
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: _vm.getPageUrl(pageNumber) },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changePage(pageNumber)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(pageNumber) + "\n\t\t\t\t"
                        ),
                      ]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "kt-pagination__link--next",
                  class: {
                    "kt-pagination__link--disabled":
                      _vm.currentPage == _vm.pageCount,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.getPageUrl(_vm.currentPage + 1) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changePage(_vm.currentPage + 1)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-angle-right" })]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "kt-pagination__link--last",
                  class: {
                    "kt-pagination__link--disabled":
                      _vm.currentPage == _vm.pageCount,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.getPageUrl(_vm.pageCount) },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.changePage(_vm.pageCount)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fa fa-angle-double-right" })]
                  ),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "kt-pagination__toolbar" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "btn-group bootstrap-select" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm dropdown-toggle",
              attrs: {
                type: "button",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
              },
            },
            [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.currentPerPage) + "\n\t\t\t\t")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu" },
            _vm._l(_vm.perPageOptions, function (option, idx) {
              return _c(
                "a",
                {
                  key: idx,
                  staticClass: "dropdown-item",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePerPage(option)
                    },
                  },
                },
                [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option) + "\n\t\t\t\t\t")]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }